module.exports = __webpack_public_path__ + "img/saba_tas_yes.3bbfc612.png";